import React from 'react'

const CircularProgressBar = (props) => {
  const { radius, stroke, progress } = props;

  let normalizedRadius = radius - stroke * 2;
  let circumference = normalizedRadius * 2 * Math.PI;

  const strokeDashoffset = circumference - progress / 100 * circumference;

  return (
    <div className='relative'>
      <svg
        height={radius * 2}
        width={radius * 2}
        style={{ transform: 'rotate(-90deg)', position: 'relative' }}
      >
        <circle
          stroke="#0057FF"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + ' ' + circumference}
          style={{ strokeDashoffset }}
          stroke-width={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <div className={`absolute top-[25px] text-[12px] ${Number(progress) === 100 ? 'left-[22px]' : 'left-[25px]'} font-light`}>{progress}%</div>
    </div>
  )
}

export default CircularProgressBar